import { render, staticRenderFns } from "./Form22StyleOfProceeding.vue?vue&type=template&id=6d4afaf0&scoped=true"
import script from "./Form22StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form22StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form22StyleOfProceeding.vue?vue&type=style&index=0&id=6d4afaf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4afaf0",
  null
  
)

export default component.exports